import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams, useSearchParams } from "react-router-dom";
import { useSakusasPanelGet } from "hooks/sakusas/panel/useSakusasPanelGet";
import PanelEdit from "./PanelEdit";
import PanelRead from "./PanelRead";

const PanelComponent = () => {
  const { panelId } = useParams();
  const [searchParams] = useSearchParams();
  const [mode, setMode] = useState<string>("");
  const panel = useSakusasPanelGet(panelId as string);
  useEffect(() => {
    const paramsMode = searchParams.get("mode") ?? "";
    if (paramsMode !== mode) {
      setMode(paramsMode);
    }
  }, [searchParams]);

  if (!panel) {
    return null;
  }

  return (
    <>
      {mode !== "edit" && <PanelRead panel={panel} />}
      {mode === "edit" && <PanelEdit panel={panel} />}
    </>
  );
};

export default PanelComponent;
